<script>
  import Button from './common/Button.svelte'

  import { step } from "./stores";

  const handleStart = () => {
    step.set(1);
  };
</script>

<div class="card card--main dekstop">
  <div class="card__main">
    <div class="card__img">
      <img src="./img/slides/start.png" alt="start" />
    </div>
    <p>
      На связи компания UCMS Group. Мы занимаемся такими серьёзными вещами, как
      расчёт ЗП или налоговый учёт, но в этом году в честь своего 25-летия
      решили немножко похулиганить и выпустили эту игру.
    </p>
    <p>Построй свою аутсорсинговую компанию и попробуй обогнать нас.</p>
  </div>
  <Button onClick={handleStart} text="Поехали!" />
</div>
